(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fdc-swatches"] && !Shopify.designMode) return;
  try {
    (function(){
    if (window.__fdcSw) return; window.__fdcSw = 1;
    function swap(d){
      if (!d.dataset.src) return;
      var card = d.closest('.fdc-card, product-card, .product-card');
      if (!card) return;
      var imgs = card.matches('.fdc-card') ? card.querySelectorAll('.fdc-card__media img') : [card.querySelector('img')];
      if (!imgs[0]) return;
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].removeAttribute('loading');
        imgs[i].srcset = d.dataset.srcset; imgs[i].src = d.dataset.src;
      }
      card.querySelectorAll('.fdc-sw__d.is-on').forEach(function(x){x.classList.remove('is-on')});
      d.classList.add('is-on');
    }
    document.addEventListener('pointerover', function(e){
      var d = e.target.closest && e.target.closest('.fdc-sw__d');
      if (d && e.pointerType === 'mouse') swap(d);
    });
    document.addEventListener('click', function(e){
      var d = e.target.closest && e.target.closest('.fdc-sw__d');
      if (d){ e.preventDefault(); e.stopPropagation(); swap(d); }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
